<template>
<b-container id="body" fluid>
  <b-row><b-col>
    <!-- <b-button v-b-toggle.sidebar-no-header><i class="fas fa-bars fa-2x" ></i></b-button><br> -->
       <div>
      <input id='fidinpt' type="text" placeholder="Enter Farmer Id" ><button @click='getFarmer'>search</button>
    </div>
    </b-col></b-row>
<b-row id="collections">
  <b-col cols="3">

  <div id="col_menu">
  <!-- <ul>
    <li>Select A collection</li>
    <li><button @click="getChildren('farmers','f')">All Farmers</button></li>
    <li><button @click="getChildren('croptypes', 'g')">Crop Types</button></li>
    <li><button @click="getChildren('primary crop','f')">Primary Crops</button></li>
    <li><button @click="getChildren('farmer crops','f')">Farmer Crops</button></li>
    <li><button @click="getChildren('counties','g')">Counties</button></li>
    <li><button @click="getChildren('livestock','g')">Livestock</button></li>
    <li><button @click="getChildren('fisheries','g')">Fisheries</button></li>
    <li><button @click="getChildren('machinery','g')">Machinery</button></li>
    <li><button @click="getChildren('tools','g')">Tools</button></li>
  </ul> -->
  </div>
  </b-col>
  <b-col v-if="!hidden2" cols="8">
    <form @submit.prevent="updateFarmer" >
      <button type="submit">update</button><br>
      <label for="">farmer_id</label>
      <input type="text" v-model="fData[0].farmer_id" id="farmer_id" ><br>
      <label for="">Title</label>
      <input type="text" v-model="fData[0].title" id="title" ><br>
      <label for="">first_name</label>
      <input type="text" v-model="fData[0].first_name" id="first_name"><br>
      <label for="">middle_name</label>
      <input type="text" v-model="fData[0].middle_name" id="middle_name"><br>
      <label for="">surname</label>
      <input type="text" v-model="fData[0].surname" id="surname" ><br>
      <label for="">gender</label>
      <input type="text" v-model="fData[0].gender" id="gender" ><br>
      <label for="">marital_status</label>
      <input type="text" v-model="fData[0].marital_status" id="marital_status" ><br>
      <label for="">dob</label>
      <input type="text" v-model="fData[0].dob" id="dob" ><br>
      <label for="">preferred_language</label>
      <input type="text" v-model="fData[0].preferred_language" id="preferred_language" ><br>
      <label for="">education_level</label>
      <input type="text" v-model="fData[0].education_level" id="education_level" ><br>
      <label for="">county</label>
      <input type="text" v-model="fData[0].county" id="county" ><br>
      <label for="">district</label>
      <input type="text" v-model="fData[0].district" id="district" ><br>
      <label for="">town</label>
      <input type="text" v-model="fData[0].town" id="town" ><br>
      <label for="">area</label>
      <input type="text" v-model="fData[0].area" id="area" ><br>
      <label for="">phone_number</label>
      <input type="text" v-model="fData[0].phone_number" id="phone_number" ><br>
      <label for="">phone_number2</label>
      <input type="text" v-model="fData[0].phone_number2" id="phone_number2" ><br>
      <label for="">farm_location</label>
      <input type="text" v-model="fData[0].farm_location" id="farm_location" ><br>
      <label for="">farm_size</label>
      <input type="text" v-model="fData[0].farm_size" id="farm_size" ><br>
      <label for="">farmer_village</label>
      <input type="text" v-model="fData[0].farmer_village" id="farmer_village" ><br>
      <label for="">farmer_address</label>
      <input type="text" v-model="fData[0].farmer_address" id="farmer_address" ><br>
      <label for="">farmers_crop</label>
      <input type="text" v-model="fData[0].farmers_crop" id="farmers_crop" ><br>
      <label for="">primary_crop</label>
      <input type="text" v-model="fData[0].primary_crop" id="primary_crop" ><br>
      <label for="">root_crops</label>
      <input type="text" v-model="fData[0].root_crops" id="root_crops" ><br>
      <label for="">tree_crops</label>
      <input type="text" v-model="fData[0].tree_crops" id="tree_crops" ><br>
      <label for="">Vegetables</label>
      <input type="text" v-model="fData[0].vegetables" id="vegetables" ><br>
      <label for="">fruits</label>
      <input type="text" v-model="fData[0].fruits" id="fruits" ><br>
      <label for="">legumes</label>
      <input type="text" v-model="fData[0].legumes" id="legumes" ><br>
      <label for="">farmers_fisheries</label>
      <input type="text" v-model="fData[0].farmers_fisheries" id="farmers_fisheries" ><br>
      <label for="">farmers_livestock</label>
      <input type="text" v-model="fData[0].farmers_livestock" id="farmers_livestock" ><br>
      <label for="">tools</label>
      <input type="text" v-model="fData[0].tools" id="tools" ><br>
      <label for="">clans</label>
      <input type="text" v-model="fData[0].clans" id="clans" ><br>
      <label for="">group_name</label>
      <input type="text" v-model="fData[0].group_name" id="group_name" ><br>
      <label for="">group_leader_name</label>
      <input type="text" v-model="fData[0].group_leader_name" id="group_leader_name" ><br>
      <label for="">group_leader_phone</label>
      <input type="text" v-model="fData[0].group_leader_phone" id="group_leader_phone" ><br>
      <label for="">crop_id</label>
      <input type="text" v-model="fData[0].crop_id" id="crop_id" ><br>
      <label for="">latitude</label>
      <input type="text" v-model="fData[0].latitude" id="latitude" ><br>
      <label for="">longitude</label>
      <input type="text" v-model="fData[0].longitude" id="longitude" ><br>
      <label for="">farmers_enrol_id</label>
      <input type="text" v-model="fData[0].farmers_enrol_id" id="farmers_enrol_id" ><br>
      <label for="">perm_farmer_card_id</label>
      <input type="text" v-model="fData[0].perm_farmer_card_id" id="perm_farmer_card_id" ><br>
      <label for="">location_id</label>
      <input type="text" v-model="fData[0].location_id" id="location_id" ><br>
      <label for="">imei</label>
      <input type="text" v-model="fData[0].imei" id="imei" ><br>
      <label for="">credity_facility</label>
      <input type="text" v-model="fData[0].credity_facility" id="credity_facility" ><br>
      <label for="">matching_grant</label>
      <input type="text" v-model="fData[0].matching_grant" id="matching_grant" ><br>
      <label for="">member_question</label>
      <input type="text" v-model="fData[0].member_question" id="member_question" ><br>
      <label for="">voter_reg_center</label>
      <input type="text" v-model="fData[0].voter_reg_center" id="voter_reg_center" ><br>
      <label for="">update_status</label>
      <input type="text" v-model="fData[0].update_status" id="update_status" ><br>
      <label for="">date_created</label>
      <input type="text" v-model="fData[0].date_created" id="date_created" ><br>
      <label for="">date_insert</label>
      <input type="text" v-model="fData[0].date_insert" id="date_insert" ><br>
      <label for="">data_source</label>
      <input type="text" v-model="fData[0].data_source" id="data_source" ><br>
      <label for="">enum_county</label>
      <input type="text" v-model="fData[0].enum_county" id="enum_county" ><br>
      <label for="">enum_district</label>
      <input type="text" v-model="fData[0].enum_district" id="enum_district" ><br>
      <label for="">enum_fullname</label>
      <input type="text" v-model="fData[0].enum_fullname" id="enum_fullname" ><br>
      <label for="">enum_phone_number</label>
      <input type="text" v-model="fData[0].enum_phone_number" id="enum_phone_number" ><br>
      <label for="">picture</label>
      <b-form-textarea
      id="picture"
      v-model="fData[0].picture"
      rows="3"
      max-rows="6" readonly>{{fData[0].picture}}</b-form-textarea><br>

    </form>
  </b-col>
<b-col> 
<div id="wholepage"> 
    <!-- <button id="change_points" @click="changePoints('Rice')">Rice</button>
  <button id="change_points" @click="changePoints('Cassava')">Cassava</button>
  <button id="change_points" @click="changePoints('Vegetables')">Vegetables</button> -->
  <b-spinner v-if="!hidden" variant="primary" label="Spinning"></b-spinner>
  <div id="geomap" style="height: 500px; width: 600px;"></div>
  <div class="china-map" id="china-map1"></div> 
  
</div>
</b-col>
</b-row>
</b-container>
</template>

<script>
import {db} from '../firebase'
// import liberiaMap from 'echarts/map/json/LBR_1'
import {GoogleCharts} from 'google-charts'
  // 主模块
// let echarts = require('echarts/lib/echarts')
//   // 散点图
// require('echarts/lib/chart/scatter')
//   // 散点图放大
// require('echarts/lib/chart/effectScatter')
//   // 地图
// require('echarts/lib/chart/map')
//   // 图例
// require('echarts/lib/component/legend')
//   // 提示框
// require('echarts/lib/component/tooltip')
//   // 地图geo
// require('echarts/lib/component/geo')
//   // 中国地图

// echarts.registerMap('liberia', liberiaMap)

export default {
  name: 'index',
  data () {
    return {
      fData: [],
      chinaMap: '',
      count: 1,
      hidden: true,
      hidden2: true,
      geoArray: [['County','Farmers']]

    }
  },
  mounted () {
    this.getMenu()
  },
  methods: {
    updateFarmer: function () {
      console.log(this.fData[0])

      db.collection('oldfarmers').doc(this.fData[0].id).set(
        this.fData[0]
      ).then(() => {
        alert('updated')
      })
    },
    getMenu: function () {
      document.getElementById('col_menu').innerHTML = ''
      document.getElementById('col_menu').innerHTML =
  '<ul><li>Select A collection</li>' +
    '<li><button id="af" >All Farmers</button></li>' +
    '<li><button  class="om" value="croptypes" name="g">Crop Types</button></li>' +
    '<li><button  class="om" value="primary_crop" name="f">Primary Crops</button></li>' +
    '<li><button  class="om" value="farmer_crops" name="f">Farmer Crops</button></li>' +
    '<li><button  class="om" value="counties" name="g">Counties</button></li>' +
  '</ul>'

      document.getElementById('af').addEventListener('click', this.getCounties)

      document.querySelectorAll('.om').forEach(
            item => {
              item.addEventListener('click', this.openMenu)
            })
    },
    getCounties: function () {
      this.hidden = false

      db.collection('counties')
      .get().then((query) => {
        const newul = document.createElement('ul')
        newul.innerHTML = '<li><button id="bbutton">back</button></li>'

        query.forEach((doc) => {
          newul.innerHTML += '<li><button class="mItem" value="' + doc.data().county_code + '">' + doc.data().name + '</button></li>'
          // console.log(doc.data().name + ' ' + doc.data().county_code)
        })

        document.getElementById('col_menu').innerHTML = ''
        document.getElementById('col_menu').appendChild(newul)
        document.getElementById('bbutton').addEventListener('click', this.getMenu)

        document.querySelectorAll('.mItem').forEach(
            item => {
              item.addEventListener('click', this.getDistricts)
            })
        this.hidden = true
      })
    },
    getDistricts: function (event) {
      var code = event.target.value
      this.hidden = false
      this.hidden2 = true

      db.collection('district')
      .where(
        'county_code',
        '==',
        code
      )
      .get().then((query) => {
        const newul = document.createElement('ul')
        newul.innerHTML = '<li><button id="bbutton">back</button></li>'

        query.forEach((doc) => {
          newul.innerHTML += '<li><button class="mItem" name="' + code + '" value="' + doc.data().name + '">' + doc.data().name + '</button></li>'
          // console.log(doc.data().name + ' ' + doc.data().county_code)
        })

        document.getElementById('col_menu').innerHTML = ''
        document.getElementById('col_menu').appendChild(newul)
        document.getElementById('bbutton').addEventListener('click', this.getCounties)

        document.querySelectorAll('.mItem').forEach(
            item => {
              item.addEventListener('click', this.getFarmers)
            })
        this.hidden = true
      })
    },
    getFarmers: function (event) {
      var district = event.target.value
      var dcode = event.target.name
      this.hidden = false

      db.collection('oldfarmers')
      .where(
        'district',
        '==',
        district
      )
      .get().then((query) => {
        const newul = document.createElement('ul')
        newul.innerHTML = '<li><button value="' + dcode + '" id="bbutton">back</button></li>'

        query.forEach((doc) => {
          newul.innerHTML += '<li><button class="mItem" value="' + doc.data().farmer_id + '">' + doc.data().title + ' ' + doc.data().first_name + ' ' + doc.data().middle_name + ' ' + doc.data().surname + '</button></li>'
          // console.log(doc.data().farmer_id + ' ' + doc.data().title + ' ' + doc.data().first_name + ' ' + doc.data().middle_name + ' ' + doc.data().surname)
        })

        document.getElementById('col_menu').innerHTML = ''
        document.getElementById('col_menu').appendChild(newul)
        document.getElementById('bbutton').addEventListener('click', this.getDistricts)

        document.querySelectorAll('.mItem').forEach(
            item => {
              item.addEventListener('click', this.editFarmers)
            })
        this.hidden = true
      })
    },
    editFarmers: function (event) {
      this.hidden2 = false
      var fid = event.target.value

      db.collection('oldfarmers')
      .where(
        'farmer_id',
        '==',
        fid
      )
      .get().then((query) => {
        this.fData = []
        query.forEach((doc) => {
          this.fData.push(
            doc.data()
          )
          this.fData[0]['id'] = doc.id

          console.log(this.fData)
        })
      })
    },
    getFarmer: function () {
      this.hidden2 = false
      var fid = document.getElementById('fidinpt').value

      db.collection('oldfarmers')
      .where(
        'farmer_id',
        '==',
        fid
      )
      .get().then((query) => {
        this.fData = []
        query.forEach((doc) => {
          this.fData.push(
            doc.data()
          )
          this.fData[0]['id'] = doc.id

          console.log(this.fData)
        })
      })
      document.getElementById('fidinpt').value = ''
    },
    openMenu: async function (event) {
      this.hidden = false
      var param1 = event.target['value']
      var param2 = event.target['name']

      if (param2 === 'g') {
        if(param1 === 'croptypes'){
        var arr = []
        var arr4 = []
        var typetype = ''
        var field = 'g'

        
        let q1 = db.collection(param1)
        let q2 = await q1.get()

        q2.docs.forEach((doc) => {
          //if (param1 === 'croptypes') {
            typetype = doc.data().crop_code
          //}
          // } else if (param1 === 'counties') {
          //   typetype = doc.data().county_code
          // } else if (param1 === 'livestock') {
          //   typetype = doc.data().type_code
          // } else if (param1 === 'fisheries') {
          //   typetype = doc.data().type_code
          // } else if (param1 === 'machinery') {
          //   typetype = doc.data().id
          // } else if (param1 === 'tools') {
          //   typetype = doc.data().id
          // }

          arr.push({
            name: doc.data().name,
            value: typetype
          })
        })

        var bar = new Promise((resolve, reject) => {
          arr.forEach(async (param, index, array) => {
         // let result = await this.getCount(param.name, field)
          // console.log(result)
            arr4.push({
              name: param.name,
              value: await this.getCount(param.name, field)
            })
            if (index === array.length - 1) resolve()
          })
        })

        bar.then(() => {
          const newul = document.createElement('ul')
          newul.innerHTML = '<li><button id="bbutton">back</button></li>'
          arr4.forEach((obj) => {
            newul.innerHTML += '<li>(' + obj.value + ')<button class="mItem" value="' + obj.name + '">' + obj.name + '</button></li>'
            console.log(obj.name + ' ' + obj.value)
          })

          document.getElementById('col_menu').innerHTML = ''
          document.getElementById('col_menu').appendChild(newul)
          document.getElementById('bbutton').addEventListener('click', this.getMenu)

          document.querySelectorAll('.mItem').forEach(
            item => {
              item.addEventListener('click', this.plotMap)
            })
          this.hidden = true
        })

        // .then(() => {

        // })
      }else if(param1 === 'counties'){

      this.hidden = false

      var query = db.collection('counties')
      var qr = await query.get()

      const newul = document.createElement('ul')
      newul.innerHTML = '<li><button id="bbutton">back</button></li>'

      for(const doc of qr.docs){

          newul.innerHTML += '<li><button class="mItem" value="' + doc.data().name + '">' + doc.data().name + '</button></li>'
          // console.log(doc.data().name + ' ' + doc.data().county_code)
        }

        document.getElementById('col_menu').innerHTML = ''
        document.getElementById('col_menu').appendChild(newul)
        document.getElementById('bbutton').addEventListener('click', this.getMenu)

        document.querySelectorAll('.mItem').forEach(
            item => {
              item.addEventListener('click', this.plotFCs)
            })
        this.hidden = true
      

      }
      }else if(param2 === 'f'){

        if(param1 === 'primary_crop'){

      document.getElementById('col_menu').innerHTML = ''
      document.getElementById('col_menu').innerHTML =
      '<ul><li>Select A collection</li>' +
        '<li><button id="bbutton" >Back</button></li>' +
        '<li><button  class="fmItem" value="lowland Rice">lowland Rice</button></li>' +
        '<li><button  class="fmItem" value="Rice">Rice</button></li>' +
        '<li><button  class="fmItem" value="Cassava" >Cassava</button></li>' +
      '</ul>'

          document.getElementById('bbutton').addEventListener('click', this.getMenu)

          document.querySelectorAll('.fmItem').forEach(
            item => {
              item.addEventListener('click', this.plotGMap)
            })
          this.hidden = true
        

      }else if(param1 === 'farmer_crops'){
      
     var query =   db.collection('crops')
     var qresult = await query.get()

       const newul = document.createElement('ul')
        newul.innerHTML = '<li><button id="bbutton">back</button></li>'

      for(const doc of qresult.docs){
 
          newul.innerHTML += '<li><button class="mItem" value="' + doc.data().name + '">' + doc.data().name + '</button></li>'
          // console.log(doc.data().name + ' ' + doc.data().county_code)
        }

        document.getElementById('col_menu').innerHTML = ''
        document.getElementById('col_menu').appendChild(newul)
        document.getElementById('bbutton').addEventListener('click', this.getMenu)

        document.querySelectorAll('.mItem').forEach(
            item => {
              item.addEventListener('click', this.plotFCrops)
            })
        this.hidden = true
      


      }
      }
    },
    plotFCs: async function(event){
      this.hidden = false
      const ecounty = String(event.target.value)
      this.geoArray = []
      this.geoArray = [['County','Farmers']]

      var counties = ['GBARPOLU','GRAND KRU','MONTSERRADO','RIVER GEE','BOMI','BONG','GRAND BASSA','GRAND CAPE MOUNT', 'GRAND GEDEH','LOFA','MARGIBI','MARYLAND','NIMBA','RIVERCESS','SINOE']
      var ps = ['LR-GP','LR-GK','LR-MO','LR-RG','LR-BM','LR-BG','LR-GB','LR-CM','LR-GG','LR-LO','LR-MG','LR-MY','LR-NI','LR-RI','LR-SI']
      var geoValues = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      // var count = 0

      let result1 = db.collection('oldfarmers').where('county','==',ecounty)
      let result2 = await result1.get()

       for (const doc of result2.docs) {  
          
          var county = doc.data().county
          
          if(county === 'GBARPOLU'){
            geoValues[0] += 1
          }else if(county === 'GRAND KRU'){
            geoValues[1] += 1
          }else if(county === 'MONTSERRADO'){
            geoValues[2] += 1
          }else if(county === 'RIVER GEE'){
            geoValues[3] += 1
          }else if(county === 'BOMI'){
            geoValues[4] += 1
          }else if(county === 'BONG'){
            geoValues[5] += 1
          }else if(county === 'GRAND BASSA'){
            geoValues[6] += 1
          }else if(county === 'GRAND CAPE MOUNT'){
            geoValues[7] += 1
          }else if(county === 'GRAND GEDEH'){
            geoValues[8] += 1
          }else if(county === 'LOFA'){
            geoValues[9] += 1
          }else if(county === 'MARGIBI'){
            geoValues[10] += 1
          }else if(county === 'MARYLAND'){
            geoValues[11] += 1
          }else if(county === 'NIMBA'){
            geoValues[12] += 1
          }else if(county === 'RIVER CESS'){
            geoValues[13] += 1
          }else if(county === 'SINOE'){
            geoValues[14] += 1
          }
          
       }

       for (var i = 0; i < counties.length; i++) {
        this.geoArray.push([
          {v: ps[i], f: counties[i]}, geoValues[i]
        ])
        console.log('geo added')
      }

      GoogleCharts.load(this.drawGeoChart, {
    'packages': ['geochart'],
    'mapsApiKey': 'AIzaSyDKcENUZqS8qbGkzyJINcnHBJoJWAcMq8U'
    });
    },
    plotFCrops: async function(event){
      this.hidden = false
      const crop = String(event.target.value)
      this.geoArray = []
      this.geoArray = [['County','Farmers']]

      var counties = ['GBARPOLU','GRAND KRU','MONTSERRADO','RIVER GEE','BOMI','BONG','GRAND BASSA','GRAND CAPE MOUNT', 'GRAND GEDEH','LOFA','MARGIBI','MARYLAND','NIMBA','RIVERCESS','SINOE']
      var ps = ['LR-GP','LR-GK','LR-MO','LR-RG','LR-BM','LR-BG','LR-GB','LR-CM','LR-GG','LR-LO','LR-MG','LR-MY','LR-NI','LR-RI','LR-SI']
      var geoValues = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      // var count = 0

      let result1 = db.collection('oldfarmers')
      let result2 = await result1.get()

       for (const doc of result2.docs) {  
         console.log(doc.data().farmers_crop)
        if (doc.data().farmers_crop.includes(crop)) {
          
          var county = doc.data().county
          
          if(county === 'GBARPOLU'){
            geoValues[0] += 1
          }else if(county === 'GRAND KRU'){
            geoValues[1] += 1
          }else if(county === 'MONTSERRADO'){
            geoValues[2] += 1
          }else if(county === 'RIVER GEE'){
            geoValues[3] += 1
          }else if(county === 'BOMI'){
            geoValues[4] += 1
          }else if(county === 'BONG'){
            geoValues[5] += 1
          }else if(county === 'GRAND BASSA'){
            geoValues[6] += 1
          }else if(county === 'GRAND CAPE MOUNT'){
            geoValues[7] += 1
          }else if(county === 'GRAND GEDEH'){
            geoValues[8] += 1
          }else if(county === 'LOFA'){
            geoValues[9] += 1
          }else if(county === 'MARGIBI'){
            geoValues[10] += 1
          }else if(county === 'MARYLAND'){
            geoValues[11] += 1
          }else if(county === 'NIMBA'){
            geoValues[12] += 1
          }else if(county === 'RIVER CESS'){
            geoValues[13] += 1
          }else if(county === 'SINOE'){
            geoValues[14] += 1
          }
          
        }
       }

       for (var i = 0; i < counties.length; i++) {
        this.geoArray.push([
          {v: ps[i], f: counties[i]}, geoValues[i]
        ])
        console.log('geo added')
      }

      GoogleCharts.load(this.drawGeoChart, {
    'packages': ['geochart'],
    'mapsApiKey': 'AIzaSyDKcENUZqS8qbGkzyJINcnHBJoJWAcMq8U'
    });
    },
    plotGMap: async function(event){
      this.hidden = false
      const crop = String(event.target.value)
      this.geoArray = []
      this.geoArray = [['County','Farmers']]

      var counties = ['GBARPOLU','GRAND KRU','MONTSERRADO','RIVER GEE','BOMI','BONG','GRAND BASSA','GRAND CAPE MOUNT', 'GRAND GEDEH','LOFA','MARGIBI','MARYLAND','NIMBA','RIVERCESS','SINOE']
      var ps = ['LR-GP','LR-GK','LR-MO','LR-RG','LR-BM','LR-BG','LR-GB','LR-CM','LR-GG','LR-LO','LR-MG','LR-MY','LR-NI','LR-RI','LR-SI']
      var geoValues = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      // var count = 0

      let result1 = db.collection('oldfarmers').where('primary_crop','==',crop)
      let result2 = await result1.get()

       for (const doc of result2.docs) {  
        if (doc.data().primary_crop === crop) {
          
          var county = doc.data().county
          
          if(county === 'GBARPOLU'){
            geoValues[0] += 1
          }else if(county === 'GRAND KRU'){
            geoValues[1] += 1
          }else if(county === 'MONTSERRADO'){
            geoValues[2] += 1
          }else if(county === 'RIVER GEE'){
            geoValues[3] += 1
          }else if(county === 'BOMI'){
            geoValues[4] += 1
          }else if(county === 'BONG'){
            geoValues[5] += 1
          }else if(county === 'GRAND BASSA'){
            geoValues[6] += 1
          }else if(county === 'GRAND CAPE MOUNT'){
            geoValues[7] += 1
          }else if(county === 'GRAND GEDEH'){
            geoValues[8] += 1
          }else if(county === 'LOFA'){
            geoValues[9] += 1
          }else if(county === 'MARGIBI'){
            geoValues[10] += 1
          }else if(county === 'MARYLAND'){
            geoValues[11] += 1
          }else if(county === 'NIMBA'){
            geoValues[12] += 1
          }else if(county === 'RIVER CESS'){
            geoValues[13] += 1
          }else if(county === 'SINOE'){
            geoValues[14] += 1
          }
          
        }
       }

       for (var i = 0; i < counties.length; i++) {
        this.geoArray.push([
          {v: ps[i], f: counties[i]}, geoValues[i]
        ])
        console.log('geo added')
      }

      GoogleCharts.load(this.drawGeoChart, {
    'packages': ['geochart'],
    'mapsApiKey': 'AIzaSyDKcENUZqS8qbGkzyJINcnHBJoJWAcMq8U'
    });

    },
        drawGeoChart: function(){
      
      console.log('geoArray')
      console.log(this.geoArray)

      var data5 = google.visualization.arrayToDataTable(this.geoArray);
      var options = {
        region: 'LR',
        resolution: 'provinces',
        displayMode: 'regions'
      };
      var geochart = new google.visualization.GeoChart(document.getElementById('geomap'));
      this.hidden = true
      geochart.draw(data5, options);
    },
    plotMap: function (event) {
      this.hidden = false
      const crop = String(event.target.value)
      // const coords = {}
      const mapData = []
      // var bigObj = []
      var two = ''

      db.collection('oldfarmers')
      .where(
        crop,
        '!=',
        'None'
      )
      .get().then((query) => {
        query.forEach((doc) => {
          var size = doc.data().farm_size
          if (size === 0 || size === undefined || size === '') {
            size = 1
          }

          mapData.push({
            name: doc.data().first_name,
            value: ([doc.data().longitude, doc.data().latitude]).concat(parseInt(size))

          })
        })
      }).then(() => {
        var oldchinamap = document.querySelector('#china-map' + this.count)
        oldchinamap.parentNode.removeChild(oldchinamap)
        var newchinamap = document.createElement('div')
        newchinamap.setAttribute('class', 'china-map')
        newchinamap.setAttribute('id', 'china-map' + (this.count + 1))
        var wholepage = document.getElementById('wholepage')
        this.hidden = true
        wholepage.appendChild(newchinamap)
        this.chinaMap = null
        two = echarts.init(document.getElementById('china-map' + (this.count + 1)))

                // const nbobj = JSON.stringify(bigObj)

      // this.$store.dispatch('drawMap', {
      //   'key1': mapData,
      //   'key2': this.chinaMap
      // })

        two.setOption({
          backgroundColor: '#272D3A',
        // 标题
          title: {
            text: '中国地图闪闪发光',
            left: 'center',
            textStyle: {
              color: '#fff'
            }
          },
        // 地图上圆点的提示
          tooltip: {
            trigger: 'item',
            formatter: function (params) {
              return params.name + ' : ' + params.value[2]
            }
          },
        // 图例按钮 点击可选择哪些不显示
          legend: {
            orient: 'vertical',
            left: 'left',
            top: 'bottom',
            data: ['Crops'],
            textStyle: {
              color: '#fff'
            }
          },
        // 地理坐标系组件
          geo: {
            map: 'liberia',
            label: {
            // true会显示城市名
              emphasis: {
                show: false
              }
            },
            itemStyle: {
            // 地图背景色
              normal: {
                areaColor: '#465471',
                borderColor: '#282F3C'
              },
            // 悬浮时
              emphasis: {
                areaColor: '#8796B4'
              }
            }
          },
        // 系列列表
          series: [
            {
              name: 'Crops2',
            // 表的类型 这里是散点
              type: 'scatter',
            // 使用地理坐标系，通过 geoIndex 指定相应的地理坐标系组件
              coordinateSystem: 'geo',
              data: mapData,
            // 标记的大小
              symbolSize: 12,
            // 鼠标悬浮的时候在圆点上显示数值
              label: {
                normal: {
                  show: false
                },
                emphasis: {
                  show: false
                }
              },
              itemStyle: {
                normal: {
                  color: '#ddb926'
                },
              // 鼠标悬浮的时候圆点样式变化
                emphasis: {
                  borderColor: '#fff',
                  borderWidth: 1
                }
              }
            },
            {
              name: 'pm2.5',
              type: 'scatter',
              scaleLimit: {min: 2, max: 2},
              coordinateSystem: 'geo',
              data: [
                    {name: 'Bomi', value: [-11.1735948, 6.6731241]},
                    {name: 'Bong', value: [-9.4900, 7.0104, 1]},
                    {name: 'Gbarpolu', value: [-10.4875, 7.0667, 1]},
                    {name: 'Grand Bassa', value: [-10.0500, 5.8833, 1]},
                    {name: 'Grand Cape Mount', value: [-11.3686, 6.7533, 1]},
                    {name: 'Grand Gedeh', value: [-8.1300, 6.0704, 1]},
                    {name: 'Grand Kru', value: [-8.1667, 4.8000, 1]},
                    {name: 'Lofa', value: [-9.7500, 8.4167, 1]},
                    {name: 'Margibi', value: [-10.3517, 6.5300, 1]},
                    {name: 'Maryland', value: [-7.7170, 4.3754, 1]},
                    {name: 'Montserrado', value: [-10.8047, 6.3106, 1]},
                    {name: 'Nimba', value: [-8.6850, 7.3710, 1]},
                    {name: 'Rivercess', value: [-9.5817, 5.4697, 1]},
                    {name: 'River Gee', value: [-7.8758, 5.1974, 1]},
                    {name: 'Sinoe', value: [-9.0388, 5.0111, 1]}
              ],
              color: '#ddb926',
              symbolSize: 0.5,
              label: {
                normal: {
                  show: true,
                  position: 'right',
                  formatter: function (params) {
                    return params.name
                  }
                }
              },
              itemStyle: {
                normal: {
                  color: '#ddb926'
                },
              // 鼠标悬浮的时候圆点样式变化
                emphasis: {
                  borderColor: '#fff',
                  borderWidth: 1
                }
              }

            }
          ]
        })

        two.resize()
        console.log(two)
        this.count++
      })
    },
    getCount: async function (name, field) {
      if (field === 'g') {
        var obj1 = {}
        obj1[name] = 0
        var count = 0

        let result1 = db.collection('oldfarmers')
        let result2 = await result1.get()

        for (const doc of result2.docs) {
          if (doc.data()[name] !== 'None' && doc.data()[name] !== undefined) {
            count = count + 1
            obj1[name] = count
          }
        }

        return count
      }
    }

  }
}
</script>
<style>

 .china-map{
    width: 500px;
    height: 500px;
  }

    #collections{
    /* position: relative;
    left: 400px; */
    background-color: #fff; 
    box-shadow: 1px 0px 20px rgb(0 0 0 / 8%);
  }

  #collections ul{
    list-style: none;
    position: relative;
    float: left;
  }

  #body{
    position: relative;
  }

  ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  width: 200px;
  background-color: #f1f1f1;
}

li a {
  display: block;
  color: #000;
  padding: 8px 16px;
  text-decoration: none;
}

li button{
  border: none;
  background: none;
}

/* Change the link color on hover */
li a:hover {
  background-color: #555;
  color: white;
}

li button:hover{
  background-color: #555;
  color: white;
}
</style>
